import { useEffect, useRef, useState } from 'react';

const useDependPendingError = <T extends any>(isPending: boolean, error?: T) => {
  const prevPendingRef = useRef(isPending);
  const [errorLocal, setErrorLocal] = useState<T | null>(null);

  useEffect(() => {
    setErrorLocal(null);
    prevPendingRef.current && !isPending && error && setErrorLocal(error);
    prevPendingRef.current = isPending;
  }, [error, isPending]);

  return errorLocal;
};

export default useDependPendingError;
